import { Box, Checkbox, FormControlLabel, Grid, Typography, TypographyTypeMap } from '@mui/material';
import { FormFields, IFormFieldConfig } from '@shared/components/FormFieldsConstructor';

interface GeneralFormPartProps<T> {
  config: IFormFieldConfig<T>[];
  useFastFields?: boolean;
  name?: string;
  color?: string;
  fontWeight?: number;
  variant?: TypographyTypeMap['props']['variant'];
  justify?: string;
  alignItems?: string;
  alignContent?: string;
  showCheckbox?: boolean;
  checkboxLabel?: string;
  checkboxChecked?: boolean;
  onCheckboxChange?: (checked: boolean) => void;
}

export const LenderUtilityFormPart = <T,>({
  config,
  useFastFields = false,
  name,
  color,
  fontWeight,
  variant = 'h3',
  justify = 'flex-start',
  alignItems = 'baseline',
  alignContent = 'stretch',
  showCheckbox = false,
  checkboxLabel,
  checkboxChecked,
  onCheckboxChange,
}: GeneralFormPartProps<T>) => (
  <Box>
    {(name || showCheckbox) && (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 1,
        }}
      >
        {name && (
          <Typography
            variant={variant as TypographyTypeMap['props']['variant']}
            color={color}
            fontWeight={fontWeight}
          >
            {name}
          </Typography>
        )}

        {showCheckbox && (
          <FormControlLabel
            label={checkboxLabel}
            control={
              <Checkbox
                checked={checkboxChecked}
                onChange={(e) => onCheckboxChange?.(e.target.checked)}
              />
            }
          />
        )}
      </Box>
    )}
    <Grid
      container
      sx={{
        justifyContent: justify,
        alignItems: alignItems,
        alignContent: alignContent,
        gap: 2,
      }}
    >
      <FormFields
        useFastFields={useFastFields}
        config={config}
      />
    </Grid>
  </Box>
);